import { FC } from 'react'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { ImageLazy } from 'shared/ui/image-lazy'

import { SkeletonPromo } from './components/skeleton'
import { Props } from './module'
import s from './styles.module.scss'

const COUNT_ONE = 1

export const Promotions: FC<Props> = ({ promoList, isLoading, onDetail }) => {
  if (isLoading) {
    return (
      <div className={s.swiperLoader}>
        {[...new Array(3)]?.map(() => (
          <SkeletonPromo
            key={nanoid()}
            className={clsx(s.promoBanner, s.promoLoader)}
          />
        ))}
      </div>
    )
  }

  return (
    <div className={s.swiper}>
      {promoList?.map((item) => (
        <div
          key={nanoid()}
          onClick={() => onDetail?.(item.id)}
          className={clsx(
            s.swiperCard,
            promoList.length === COUNT_ONE && s.center,
          )}
        >
          <ImageLazy
            src={item.baner}
            alt={item.title}
            className={clsx(
              s.promoBanner,
              promoList.length == COUNT_ONE && s.fullWidth,
            )}
          />
        </div>
      ))}
    </div>
  )
}
